/*Public JS - Version 1*/
import * as dataGetter from "./modules/wp-wpp-data-getter.js";
import { isValid, phoneMask } from "./modules/wp-wpp-data-validation.js"

(function () {
    let wppPopUp = document.querySelector('.floating-wpp-modal');
    let wppButtons = document.querySelectorAll('.wp-wpp-open-button');
    let wppForm = document.querySelector('.wp-wpp-form form');
    let wppRequiredFields = document.querySelectorAll('.wp-wpp-form form [aria-required="true"]');
    let wppTelFields = document.querySelectorAll('.wp-wpp-form form input[type="tel"]');
    let wppContactField = document.querySelector('.wp-wpp-form form select');
    let wppSubmitButton = document.querySelector('.wp-wpp-form form input[type="submit"]');

    function addOpenModalListeners(button) {
        button.addEventListener('click', function(event) {
            wppPopUp.classList.toggle('active');
            event.preventDefault();
        });
    }

    function sendForm(event) {
        event.preventDefault();

        if (isValid(wppRequiredFields)) {
            openWhatsapp();
        }
    }

    function openWhatsapp() {
        const contact = document.querySelector('.wp-wpp-form form select[name="contact"]').value;
        wpWpp.contactMessage = replacePlaceholders(wpWpp.contactMessage);
        window.open('https://api.whatsapp.com/send?phone=' + contact + '&text=' + wpWpp.contactMessage, wpWpp.openInAnotherTab ? '_blank' : '_self');
    }

    function replacePlaceholders(message) {
        message = message.replace('{url}', window.location.href);

        wppRequiredFields.forEach(function (field) {
            message = message.replace('{' + field.name + '}', field.value);
        })

        return message;
    }

    function addContactSelect() {

        let options = [];
        
        if (wpWpp.phones.length <= 1) {
            wppContactField.classList.add('hidden');
        }

        wpWpp.phones.forEach((phone, index) => {
            options.push(`<option value="${phone}">${wpWpp.aliases[index]}</option>`);
        });

        wppContactField.innerHTML = options.join('');
    }

    if (wppButtons.length > 0) {
        wppButtons.forEach(addOpenModalListeners);
    }

    if (wppTelFields.length > 0) {
        wppTelFields.forEach(phoneMask);
    }

    if (wppForm) {
        wppForm.addEventListener('submit', sendForm);
    }

    addContactSelect();
})();